import request from '@/http/http'
const PREFIX = 'api/deer/customers';
// 获取客源列表
export function getCustomers(query) {
  return request({
    url: PREFIX,
    params: query
  })
}
// 创建客源
export function createCustomer(data) {
  return request({
    url: PREFIX,
    method:'post',
    data
  })
}
// 删除客源
export function deleteCustomer(id) {
  return request({
    url: PREFIX+'?customerId='+id,
    method:'delete',
  })
}
// 批量删除客源
export function deleteCustomers(data) {
  return request({
    url: PREFIX+'/batch-delete?'+data,
    method:'delete',
  })
}
// 编辑客源
export function updateCustomer(id,data) {
  return request({
    url: PREFIX+'?customerId='+id,
    method:'put',
    data
  })
}
// 获取客源详情
export function getCustomerInfo(id) {
  return request({
    url: PREFIX+'/'+id,
  })
}
// 获取成交信息列表
export function getFinishes(id) {
  return request({
    url: PREFIX+'/'+id+'/finish-list',
  })
}
// 获取跟进记录列表
export function getFollows(id) {
  return request({
    url: PREFIX+'/'+id+'/follow-list',
  })
}
// 添加跟进信息
export function addFollow(id,data) {
  return request({
    url: PREFIX+'/'+id+'/add-follow',
    method:'post',
    data
  })
}
// 获取联系人列表
export function getContracts(id) {
  return request({
    url: PREFIX+'/'+id+'/contract-list',
  })
}
// 添加联系人
export function addContract(id,data) {
  return request({
    url: PREFIX+'/'+id+'/add-contract',
    method:'post',
    data
  })
}
// 更新联系人
export function updateContract(id,contractId,data) {
  return request({
    url: PREFIX+'/'+id+'/'+contractId+'/update-contract',
    method:'put',
    data
  })
}
// 查看客源电话
export function getCustomerPhone(id) {
  return request({
    url: PREFIX+'/'+id+'/phone',
  })
}
// 获取联系人电话
export function getContractPhone(id) {
  return request({
    url: PREFIX+'/'+id+'/contract-phone',
  })
}
// 更新等级
export function updateAttentionLevel(id,level) {
  return request({
    url: PREFIX+'/'+id+'/update-attention-level?attentionLevel='+level,
    method:'put',
  })
}

// 获取操作事件列表
export function getHistoryActions() {
  return request({
    url: PREFIX+'/history-action-list',
  })
}

// 获取操作日志
export function getHistorypages(query) {
  return request({
    url: PREFIX+'/history-page-list',
    params: query
  })
}

// 删除联系人
export function deleteContract(customerId,contractId) {
  return request({
    url: PREFIX+'/'+customerId+'/'+contractId+'/contract',
    method:'delete',
  })
}

// 获取我的用户列表
export function getMyCustomers(query) {
  return request({
    url: PREFIX+'/my-list',
    params: query
  })
}